<script>
  import { slide } from 'svelte/transition';
  
  let active = false;
  let code = '';
  let error = false;
  let disabled = false;

  const reset = () => {
    active = false;
    code = '';
    error = false;
    disabled = false;
  }

  const validate = () => {
    disabled = true;
    error = true;
    code = 'Niepoprawny kod.'
    setTimeout(reset, 2000)
  }
</script>


<div class="promocode"  transition:slide={{duration: 200}}>
  {#if active}
    <div class="promocode__field">
      <input type="text" bind:value={code} class="promocode__input" class:error placeholder="Wpisz kod" />
      <div class="promocode__apply button" class:disabled on:click={validate}>Dodaj</div>
    </div>
  {:else}
    <a class="promocode__trigger" on:click={() => active = true}>Mam kod promocyjny</a>
  {/if}
</div>


<style>
  .promocode {
    margin-bottom: 30px;
  }

  .promocode__field {
    display: flex;
    justify-content: stretch;
    width: 100%;
  }

  .promocode__trigger {
    display: inline-block;
  }

  .promocode__input {
    border: 1px solid #e0e0e0;
    padding: 10px 15px;
    box-sizing: border-box;
    font-family: inherit;
    font-weight: lighter;
    font-size: 1em;
    flex-grow: 1;
  }

  .promocode__input.error {
    color: red;
  }

  .promocode__apply {
    font-size: 0.8em;
    box-shadow: none;
  }

  .promocode__apply.disabled {
    cursor: default;
    pointer-events: none;
    background-color: #e0e0e0;
  }
</style>
